import React from "react";
import "./style.css";

const MissionContent = () => {
  return (
    <section className="mission-content">
      <div className="mission-content__inner">
        <div className="mission-content__statement">
          <p className="mission-content__paragraph">
            Misiunea mea este să <strong>inspir</strong> oamenii să își creeze o
            viață mai {" "}
            <strong>echilibrată</strong>, mai <strong>blândă</strong> și mai{" "}
            <strong>conectată</strong> cu ei înșiși, prin informare, educație
            holistică și cu ajutorul uleiurilor esențiale certificate cu grad
            terapeutic.
          </p>
        </div>

        <div className="mission-content__divider">
          <span className="mission-content__divider-line" />
          <span className="mission-content__divider-dot" />
          <span className="mission-content__divider-line" />
        </div>

        <div className="mission-content__statement">
          <p className="mission-content__paragraph">
            Cred că adevărata stare de bine începe atunci când învățăm să ne
            ascultăm corpul, să ne înțelegem emoțiile și să ne oferim momente de
            liniște și reconectare în mijlocul agitației zilnice.
          </p>
        </div>

        <div className="mission-content__divider">
          <span className="mission-content__divider-line" />
          <span className="mission-content__divider-dot" />
          <span className="mission-content__divider-line" />
        </div>

        <div className="mission-content__closing-block">
          <p className="mission-content__paragraph">
            Prin tot ceea ce transmit, îmi doresc să ofer nu doar produse, ci
            experiențe care aduc <strong>calm</strong>,{" "}
            <strong>claritate</strong>, <strong>echilibru</strong> și o{" "}
            <strong>stare </strong> <strong>autentică</strong>  {" "}
            de acasă — în propriul trup, minte și suflet.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionContent;
